import { Alert, Card, Stack } from "@bvhi/ui-base";
import { NavigationBar } from "../../../../components/navigation-bar.tsx";
import { GetPlattformMessagesParams, useGetPlattformMessages } from "@bvhi/backend-api/index.ts";
import { useErrorObjectMapper } from "../../../../hooks/use-error-object-mapper.tsx";
import { useBVHIDataGridFilter } from "../../../../hooks/use-bvhi-datagrid-Filter.ts";
import { Route } from "../../../../routes/_main/app/messages.index.tsx";
import { keepPreviousData } from "@tanstack/react-query";
import { Suspense, useMemo } from "react";
import { ErrorIcon } from "@bvhi/ui-icons";
import { MessagesDataGrid } from "./components/messages-data-grid.tsx";
import { MessagesFilterCard } from "./components/messages-filter-card.tsx";
import { defaultMessagesFilter } from "./components/default-messages-filter.ts";

export const MessagesListView = () => {
  const searchParams = Route.useSearch();

  const { getErrorMessagesFromErrorObject } = useErrorObjectMapper();
  const { handleDataGridChange, handleFilterChange, resetFilter, requestParams } = useBVHIDataGridFilter<GetPlattformMessagesParams>(
    defaultMessagesFilter,
    Route.fullPath,
    undefined,
    searchParams
  );

  const { error } = useGetPlattformMessages(requestParams, {
    query: { throwOnError: (error) => error.status === 500 || error.status === 403, placeholderData: keepPreviousData },
  });

  const errorMessages = useMemo(() => {
    if (!error?.errors) return [];
    const errItems = getErrorMessagesFromErrorObject(error);
    return errItems.map((errItem) => (
      <Alert key={errItem} icon={<ErrorIcon />} severity="error">
        {errItem}
      </Alert>
    ));
  }, [error, getErrorMessagesFromErrorObject]);
  return (
    <>
      <NavigationBar showBreadcrumbs={true} />
      <Stack pt={2} spacing={2}>
        {errorMessages.map((errorComponent) => errorComponent)}
        <MessagesFilterCard filter={requestParams} onChange={handleFilterChange} onReset={resetFilter} />
        <Suspense fallback={<Card sx={{ height: 300, minHeight: 300 }} />}>
          <MessagesDataGrid updateCallback={handleDataGridChange} />
        </Suspense>
      </Stack>
    </>
  );
};
